import React from 'react'
import { startOfDay } from 'date-fns'
// Local
import { BASE_URL } from '../../config'
import { API_URL } from '../../constant'

/**
 * Provides a component that renders a PDF huddle report in an iframe
 * The huddle report can include all encounters ready for physician on a
 * given date or can include just the encounters for a specified physician
 * @param startDt Optional. Default: current date. If provided, a millisecond
 *        date value (Date.getTime()) that specifies the huddle start date
 * @param practitionerId Optional. If provided, constrain encounters to the
 *        specified practitioner
 */

type Props = {
  orgId?: string | undefined
  practitionerId?: string | undefined
  region: string
  startDt?: Date | number | undefined
}

function PdfHuddleReport(
  props: Props
): JSX.Element {
  const {
    orgId,
    practitionerId,
    region,
    startDt
  } = props
  const pdfUrl = (): string => {
    const start = startDt
      ? startOfDay(new Date(startDt))
      : startOfDay(new Date())

    if (practitionerId) {
      const practitionerHuddleReport = API_URL.PDF_PRACTITIONER_HUDDLE_REPORT(
        practitionerId,
        start.getTime()
      )
      return `${BASE_URL}${practitionerHuddleReport}`
    }
    if (orgId) {
      const pdfOrgHuddleReport = API_URL.PDF_ORG_HUDDLE_REPORT(
        orgId,
        start.getTime()
      )
      return `${BASE_URL}${pdfOrgHuddleReport}`
    }
    if (region) {
      const pdfRegionHuddleReport = API_URL.PDF_REGION_HUDDLE_REPORT(
        region,
        start.getTime()
      )
      return `${BASE_URL}${pdfRegionHuddleReport}`
    }
    const pdfHuddleReport = API_URL.PDF_HUDDLE_REPORT(start.getTime())
    return `${BASE_URL}${pdfHuddleReport}`
  }

  const url = pdfUrl()
  return (
    <iframe
      title="Huddle PDF"
      className="pdf-iframe"
      src={ url }
    />
  )
}

export default PdfHuddleReport
